import { createRouter, createWebHistory } from "vue-router";
import Dashboard from "../views/Dashboard.vue";
import Profile from "../views/Profile.vue";
import Signup from "../views/Signup.vue";
import Signin from "../views/Signin.vue";
import UsersList from "../views/UsersList.vue";
import { useAuthStore } from "@/store/authStore";
import CategoryList from "../views/CategoryList.vue";
import AmenityList from "../views/AmenityList.vue";
import HouseList from "../views/HouseList.vue";
import ContactList from "../views/ContactList.vue";
import BlogCategoryList from "../views/BlogCategoryList.vue";
import BlogList from "../views/BlogList.vue";
import BlogPostDetail from "../views/BlogPostDetail.vue";
import SubscribersList from "../views/SubscribersList.vue";
import ResetPassword from "../views/ResetPassword.vue";
import ForgotPassword from "../views/ForgotPassword.vue";

// Define Routes
const routes = [
  {
    path: "/",
    name: "/",
    redirect: "/dashboard-default",
  },
  {
    path: "/dashboard-default",
    name: "Dashboard",
    component: Dashboard,
    meta: { requiresAuth: true },
  },
 
  {
    path: "/lista-de-agentes",
    name: "lista-de-agentes",
    component: UsersList,
    meta: { requiresAuth: true, requiresAdmin: true },
  },
  {
    path: "/categorias",
    name: "categorias",
    component: CategoryList,
    meta: { requiresAuth: true, requiresAdmin: true },
  },
  {
    path: "/amenidades",
    name: "amenidades",
    component: AmenityList,
    meta: { requiresAuth: true, requiresAdmin: true },
  },
  {
    path: "/casas",
    name: "casas",
    component: HouseList,
    meta: { requiresAuth: true, requiresAdmin: true },
  },
  {
    path: "/contacto",
    name: "contacto",
    component: ContactList,
    meta: { requiresAuth: true, requiresAdmin: true },
  },
  {
    path: "/blogs",
    name: "Blogs",
    component: BlogList,
    // meta: { requiresAuth: true, requiresAdmin: true },
  },
  
  {
    path: '/crearblog',
    name: 'Crear blog',
    component: BlogPostDetail,
  },
  {
    path: '/blogdetails/:id',
    name: 'BlogDetail',
    component: BlogPostDetail,
    meta: { requiresAuth: true, requiresAdmin: true },

  },
  {
    path: "/blog-categorias",
    name: "blog-categorias",
    component: BlogCategoryList,
    meta: { requiresAuth: true, requiresAdmin: true },
  },
 
  {
    path: "/suscriptores",
    name: "suscriptores",
    component: SubscribersList,
    meta: { requiresAuth: true },
  },  
  {
    path: "/profile",
    name: "Profile",
    component: Profile,
    meta: { requiresAuth: true },
  },
  {
    path: "/signin",
    name: "Signin",
    component: Signin,
  },
  {
    path: "/signup",
    name: "Signup",
    component: Signup,
  },
  {
    path: '/forgot-password',
    name: 'ForgotPassword',
    component: ForgotPassword
  },
  
  {
    path: '/reset-password',
    name: 'ResetPassword',
    component: ResetPassword
  }

  
];

// Create Router
const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  linkActiveClass: "active",
});

// Global Navigation Guard
router.beforeEach(async (to, from, next) => {
  const authStore = useAuthStore();

  // Wait for Pinia store to hydrate if necessary (safety for SSR or async plugin cases)
  await Promise.resolve(); // optional, in case hydration is async

  // Auto logout if token expired
  if (authStore.token && authStore.isTokenExpired()) {
    authStore.logout();
    return next("/signin");
  }

  const isAuthenticated = !!authStore.token;
  const isAdmin = authStore.isAdmin();

  if (to.meta.requiresAuth && !isAuthenticated) {
    return next("/signin");
  }

  if (to.meta.requiresAdmin && !isAdmin) {
    return next("/signin");
  }

  next();
});


export default router;
